import { render, staticRenderFns } from "./Staking1.vue?vue&type=template&id=7eaa0f30&scoped=true&"
import script from "./Staking1.vue?vue&type=script&lang=js&"
export * from "./Staking1.vue?vue&type=script&lang=js&"
import style0 from "./Staking1.vue?vue&type=style&index=0&id=7eaa0f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaa0f30",
  null
  
)

export default component.exports